import { vmLeadformCountStats } from '../../util/vmCookieHandler';
import { setVmFormCount } from '../../util/vmStorageHandler';
import {
  SET_CONFIG,
  SET_EVENT,
  SET_IS_SUBMITTING,
  SET_TIME_LEFT,
  SET_IS_RESEND_VISIBLE,
  SET_IS_LEAD_FORM_VISIBLE,
  SET_BASIC_DETAIL,
  SET_IS_OTP_INVALID,
  SET_FREE_FOOD_LEAD_FORM_VISIBLE_STATE,
  SET_CONNECT_VM_LEAD_FORM_VISIBLE_STATE,
  SHOW_OTP_SEGMENT_FFTVM,
  WRONG_OTP_STATE,
  SET_HAVE_US_CALL_YOU_FORM_VISIBLE_STATE,
  SET_ENQUIRY_VISIBLE_STATE,
  SET_ENQIRY_FORM_PARAMS,
  SIDEBAR_HAVE_US_CALL_YOU_FILLED,
  SET_SELECTED_CATATAGORY_TYPE,
  SET_IS_HOME_LEAD_FORM_VISIBLE
} from '../actions/LeadFormActions';

// [user => 1, detail => 2, date => 3] >>> [detail => 1, date => 2, user => 3]
const initialState = {
    config: {
        view: 'detail',
        otpView: false,
        skipVisible: false,
        isEdit: false,
    },
    isSubmitting: false,
    isResend: false,
    event: null,
    timeLeft: 60,
    isResendVisible: false,
    isOtpInvalid: true,
    isLeadFormVisible: false,
    isHomeLeadFormVisible: false,
    basicDetails: null,
    leadformVisibleCount: 0,
    isWrongOtpEntered: false,
    haveUsCallYourFormVisibleState: false,
    enquiryFormParams:{},
    enquiryFormVisibleState:false,
    sideBarHaveUsCallYouFilled:false,
    selectedCatagory:'',
    leadFormTriggerCode:false,
    showOtpSegmentForFFTVM: false,

};

const LeadFormReducer = (state = initialState, action) => {
  let leadformVisibleCount = state.leadformVisibleCount || 0;
  switch (action.type) {
    case SET_CONFIG:
      return {
        ...state,
        config: action.config,
      };
    case SET_IS_OTP_INVALID:
      return {
        ...state,
        isOtpInvalid: action.isOtpInvalid,
      };
    case SET_SELECTED_CATATAGORY_TYPE:
      return {
        ...state,
        selectedCatagory:action.selectedCatagory
      }  
    case SET_EVENT:
      return {
        ...state,
        event: action.event,
      };
    case SET_IS_SUBMITTING:
      return {
        ...state,
        isSubmitting: action.isSubmitting,
      };
    case SET_TIME_LEFT:
      return {
        ...state,
        timeLeft: action.timeLeft,
      };
    case SET_IS_RESEND_VISIBLE:
      return {
        ...state,
        isResendVisible: action.isResendVisible,
      };
    case SET_IS_LEAD_FORM_VISIBLE:
      if (!!action.isLeadFormVisible) {
        leadformVisibleCount += 1;
        setVmFormCount(leadformVisibleCount);
        vmLeadformCountStats();
      }
      return {
        ...state,
        selectedLeadForm: action.selectedLeadForm,
        isLeadFormVisible: action.isLeadFormVisible,
        leadformVisibleCount: leadformVisibleCount,
        leadFormTriggerCode: action.leadFormTriggerCode
      };
        case SET_IS_HOME_LEAD_FORM_VISIBLE:
      if (!!action.isHomeLeadFormVisible) {
        leadformVisibleCount += 1;
        setVmFormCount(leadformVisibleCount);
        vmLeadformCountStats();
      }
      return {
        ...state,
        selectedLeadForm: action.selectedLeadForm,
        isHomeLeadFormVisible: action.isHomeLeadFormVisible,
        leadformVisibleCount: leadformVisibleCount,
        leadFormTriggerCode: action.leadFormTriggerCode
      };  
    case SET_BASIC_DETAIL:
      return {
        ...state,
        basicDetails: action.basicDetails,
      };
      case SET_FREE_FOOD_LEAD_FORM_VISIBLE_STATE:
      return {
        ...state,
        freeFoodLeadFormVisibleState: action.freeFoodLeadFormVisibleState
      };

    case SHOW_OTP_SEGMENT_FFTVM:
      return {
        ...state,
        showOtpSegmentForFFTVM: action.showOtpSegmentForFFTVM
      };
    case SET_CONNECT_VM_LEAD_FORM_VISIBLE_STATE:
      return {
        ...state,
        connectVmLeadFormVisibleState: action.connectVmLeadFormVisibleState,
      };
    case WRONG_OTP_STATE:
      return {
        ...state,
        isWrongOtpEntered: action.payload
      }

    case SET_HAVE_US_CALL_YOU_FORM_VISIBLE_STATE:
      return {
        ...state,
        haveUsCallYourFormVisibleState: action.haveUsCallYourFormVisibleState
      }

    case SET_ENQUIRY_VISIBLE_STATE:
      return {
        ...state,
        enquiryFormVisibleState: action.enquiryFormVisibleState,
        ...(action.enquiryFormVisibleState === false ? { showOtpSegmentForFFTVM: false } : {}),
      };
    
    case SET_ENQIRY_FORM_PARAMS:
      return {
          ...state,    
          enquiryFormParams:
            action.enquiryFormParams
          
      };  
    case SIDEBAR_HAVE_US_CALL_YOU_FILLED:
      return {
          ...state, 
         sideBarHaveUsCallYouFilled:action.sideBarHaveUsCallYouFilled
          
      };  
    default: return state;
  }
};

export default LeadFormReducer;

